/*
This module is used to ensure a correct module order in the generated bundle.
This is necessary because of cyclic dependencies between ArticleElement and its derived classes.
Important: Every locale module has to import from this module!
*/
//// export base classes first in order of inheritance
export * from "./ArticleElement";
////
export * from "./AppModule";
export * from "./ArticleImport";
export * from "./ArticleManager";
export * from "./ArticlePropertyHelpers";
export * from "./ArticleTypes";
export * from "./BoundingBoxDimensions";
export * from "./Defaults";
export * from "./Helpers";
export * from "./MainArticleElement";
export * from "./PlaceholderCreator";
export * from "./SubArticleElement";
export * from "./SubArticleHighlight";
export * from "./UserArticleElement";
